(ns com.theplantscape.plant-web.draw.db.data.tools)

(def actions
  [{:tool/name :structure
    :tool/label "Insert structure"
    :tool/icon "fa-house"
    :tool/description "Create a building / Permanent structure"
    :tool/action :set-structure-tool}
   {:tool/name :patch
    :tool/label "Insert Patch"
    :tool/icon "fa-landmark"
    :tool/description "Create a patch of plants or polycultures"
    :tool/action :set-patch-tool}
   {:tool/name :area
    :tool/label "Insert Area"
    :tool/icon "fa-landmark"
    :tool/description "Custom Coloured area Pond / Lawn / Patio"
    :tool/action :set-area-tool}
   {:tool/name :path
    :tool/label "Path"
    :tool/icon "fa-shoe-prints"
    :tool/description "Create a foot path"
    :tool/action :set-path-tool}
   {:tool/name :measure
    :tool/icon "fa-ruler"
    :tool/label "Measure"
    :tool/description "Measure between points"
    :tool/action :set-measure}
   {:tool/name :search
    :tool/label "Search"
    :tool/icon "fa-search"
    :tool/action :set-search-tool
    :tool/description "Search for plant"}
   {:tool/name :trash
    :tool/icon "fa-trash"
    :tool/label "Trash"
    :tool/description "Remove all objects from diagram"
    :tool/action :reset-diagram}
   {:tool/name :load
    :tool/icon "fa-save"
    :tool/label "Load"
    :tool/action :load
    :tool/description "Load diagram from browser store"}
   {:tool/name :save
    :tool/icon "fa-save"
    :tool/label "Save"
    :tool/action :save
    :tool/description "Save diagram from browser store"}
   {:tool/name :center-canvas
    :tool/icon "fa-location-crosshairs"
    :tool/label "Center Canvas"
    :tool/action :center-canvas
    :tool/description "Center canvas"}
   {:tool/name :share
    :tool/icon "fa-share"
    :tool/label "Share"
    :tool/description "Share design"
    :tool/action :share-svg}
   {:tool/name :export
    :tool/icon "fa-save"
    :tool/label "Export"
    :tool/description "Export as svg image."
    :tool/action :export-svg}])

